import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=0d237715&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d237715')) {
      api.createRecord('0d237715', component.options)
    } else {
      api.reload('0d237715', component.options)
    }
    module.hot.accept("./Terms.vue?vue&type=template&id=0d237715&", function () {
      api.rerender('0d237715', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Terms/Terms.vue"
export default component.exports